import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=dcc5de1e&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=dcc5de1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc5de1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcc5de1e')) {
      api.createRecord('dcc5de1e', component.options)
    } else {
      api.reload('dcc5de1e', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=dcc5de1e&scoped=true", function () {
      api.rerender('dcc5de1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/Tabs.vue"
export default component.exports